import { useEffect, useState } from "react";
import { adminListComplaints } from "../../api";
import { useSession } from "../../state";

type Complaint = {
  id: string;
  user_id: string | null;
  reason: string;
  related_url: string | null;
  contact: string | null;
  body: string;
  created_at: string;
};

export function AdminComplaints() {
  const { token } = useSession();
  const [rows, setRows] = useState<Complaint[]>([]);

  useEffect(() => {
    (async () => {
      const t = (await token())!;
      setRows(await adminListComplaints(t));
    })();
  }, []);

  if (rows.length === 0) return <p className="text-ink-soft text-sm">no complaints yet.</p>;

  return (
    <ul className="space-y-3">
      {rows.map((c) => (
        <li key={c.id} className="border border-ink/10 rounded-2xl p-4 bg-cream-dark/40">
          <div className="flex justify-between text-xs text-ink-mute mb-1">
            <span><b className="text-ink">{c.reason}</b> · {c.contact || "(no contact)"}</span>
            <span>{new Date(c.created_at).toLocaleString()}</span>
          </div>
          {c.related_url && <p className="text-xs mb-1 break-all"><a className="underline" href={c.related_url} target="_blank">{c.related_url}</a></p>}
          <p className="text-sm whitespace-pre-wrap">{c.body}</p>
        </li>
      ))}
    </ul>
  );
}
